"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarBadge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const bem_helper_1 = require("../../helpers/bem-helper");
const CustomSvgIcon_1 = __importDefault(require("../Icon/CustomSvgIcon/CustomSvgIcon"));
const AvatarConstants_1 = require("./AvatarConstants");
require("./AvatarBadge.scss");
const AVATAR_CSS_BASE_CLASS = "monday-style-avatar-badge";
const bemHelper = (0, bem_helper_1.BEMClass)(AVATAR_CSS_BASE_CLASS);
const AvatarBadge = (_a) => {
    var { src, ariaLabel, tabIndex, className, size } = _a, otherProps = __rest(_a, ["src", "ariaLabel", "tabIndex", "className", "size"]);
    return src ? ((0, jsx_runtime_1.jsx)(CustomSvgIcon_1.default, Object.assign({ src: src, ariaLabel: ariaLabel, className: (0, classnames_1.default)(AVATAR_CSS_BASE_CLASS, bemHelper({ state: size }), className), clickable: tabIndex === -1 }, otherProps))) : null;
};
exports.AvatarBadge = AvatarBadge;
Object.assign(exports.AvatarBadge, {
    sizes: AvatarConstants_1.AvatarSize
});
exports.AvatarBadge.defaultProps = {
    ariaLabel: undefined,
    tabIndex: 0,
    className: "",
    size: AvatarConstants_1.AvatarSize.LARGE
};
